/* Request-a-quote page: carry the buyer's configuration into the Shopify Forms message field.
   The form lives in a shadow root and renders late, so wait for it, then set the value the way a
   keystroke would. The configuration arrives as ?config=… (kit builder) and is kept for the visit. */
(() => {
  let config = new URLSearchParams(location.search).get('config');
  try { if (config) sessionStorage.setItem('dnova-config', config); else config = sessionStorage.getItem('dnova-config'); } catch (e) { /* storage blocked: the URL value still works */ }
  if (!config) return;
  const setter = Object.getOwnPropertyDescriptor(HTMLTextAreaElement.prototype, 'value').set;
  const message = `Please quote this configuration:

${config}

Quantity: 
Delivery country: `;
  let tries = 0;
  const fill = () => {
    const host = document.querySelector('shopify-forms-embed');
    const field = host && host.shadowRoot && host.shadowRoot.querySelector('textarea[name="custom#productservice_details"]');
    if (field) {
      if (!field.value) { setter.call(field, message); field.dispatchEvent(new Event('input', { bubbles: true })); field.dispatchEvent(new Event('change', { bubbles: true })); }
      const note = document.querySelector('.dn-quote-note');
      if (!note) {
        const n = document.createElement('p'); n.className = 'dn-quote-note';
        n.textContent = 'Your configuration is filled in below. Add the quantity and delivery country and send it.';
        host.parentNode.insertBefore(n, host);
      }
      return;
    }
    if (++tries < 60) setTimeout(fill, 250);
  };
  fill();
})();
